<script lang="ts">
    import { Button } from "carbon-components-svelte";
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import { Tag, Notification } from "../../../../../node_modules/svelma/src";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { locationStore } from "../../../../store/locations";
    import { networkStore } from "../../../../store/networks";
    import { player, user } from "../../../../store/stores";

    let registered: boolean = false;
    let formData:
        | undefined
        | {
              orientations: any[];
              rotations: any[];
          };

    let selectedOrientation: any;
    let selectedRotation: any;
    let registerPlayerResponseStatus: number | null = null;
    let qrUrlSearchParams: any;

    export let networkId: string;
    export let locationId: string;
    // export let playerId: string;

    const statusHandler = (status: number) => {
        registerPlayerResponseStatus = status;
        switch (status) {
            case 201:
                Notification.create({
                    message: "Player successfully registered!",
                    type: "is-success",
                });
                registered = true;
                navigate(
                    "../" +
                        qrUrlSearchParams.get("playerid") +
                        "/configure?" +
                        qrUrlSearchParams.toString()
                );
                break;
            case 409:
                Notification.create({
                    message: "Player already registered!",
                    type: "is-warning",
                });
                registered = true;
                break;
            default:
                Notification.create({
                    message:
                        "You opened this programmatically because it failed!",
                    type: "is-danger",
                });
                break;
        }
    };

    const getFormdataForPlayer = async () => {
        if ($player.fingerprint && $player.uuid) {
            await fetch("https://keycloak-dev.whizad.io/provision/formData", {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + $user.token,
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    formData = data;
                    return;
                });
        }
    };

    const getLocation = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.getLocation({ locationId: locationId })
                .then((location) => {
                    locationStore.update((store) => {
                        return {
                            ...store,
                            location: location,
                        };
                    });
                });
        });
    };

    const getNetwork = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.getNetwork({ networkId: networkId })
                .then((network) => {
                    networkStore.update((store) => {
                        return {
                            ...store,
                            network: network,
                        };
                    });
                });
        });
    };

    const updatePlayer = async () => {
        const updatedParamsObject = {
            rotation: selectedRotation.value,
            orientation: selectedOrientation.value,
            locationId: $locationStore.location.id,
        };
        let params = new URLSearchParams();
        params.set("orientation", selectedOrientation.value);
        params.set("rotation", selectedRotation.value);
        if ($player.fingerprint && $player.uuid) {
            await fetch(
                "https://keycloak-dev.whizad.io/provision/update/" +
                    $player.uuid +
                    "/" +
                    $player.token +
                    "?" +
                    params.toString(),
                {
                    method: "PUT",
                    headers: {
                        Authorization: "Bearer " + $user.token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(updatedParamsObject),
                }
            ).then((resp) => resp.json());
        }
    };

    onMount(async () => {
        if ($player.fingerprint && $player.uuid) {
            await fetch(
                "https://keycloak-dev.whizad.io/provision/check/" +
                    $player.fingerprint +
                    "/" +
                    $player.uuid,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + $user.token,
                    },
                }
            )
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.confirmationStatus === "CONFIRMED") {
                        registered = true;
                        return;
                    }
                    registered = false;
                });
        }
        getFormdataForPlayer();
        if (
            !$locationStore.location ||
            $locationStore.location.id !== locationId
        ) {
            getLocation();
        }
        if (!$networkStore.network || $networkStore.network.id !== networkId) {
            getNetwork();
        }
    });
</script>

<main>
    <div class="card fullwidth fullheight">
        <div class="card-content">
            <div class="content">
                <div class="columns is-multiline">
                    <div class="column">
                        <p><b>Player-ID:</b> {$player.uuid}</p>
                        <p><b>Token:</b> {$player.token}</p>
                        <div class="status">
                            <b>Status:</b>
                            <Tag
                                class="inline"
                                type={registered ? "is-primary" : "is-danger"}
                            >
                                {registered
                                    ? "Registered"
                                    : "not registered"}</Tag
                            >
                        </div>
                    </div>
                    <div class="column">
                        {#if formData && formData.orientations}
                            <div class="block">
                                <div class="select">
                                    <!-- svelte-ignore a11y-no-onchange -->
                                    <select
                                        bind:value={selectedOrientation}
                                        on:change={updatePlayer}
                                    >
                                        {#each formData.orientations as orientation}
                                            <option value={orientation}
                                                >{orientation.description}</option
                                            >
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        {/if}
                        {#if formData && formData.rotations}
                            <div class="block">
                                <div class="select">
                                    <!-- svelte-ignore a11y-no-onchange -->
                                    <select
                                        bind:value={selectedRotation}
                                        on:change={updatePlayer}
                                    >
                                        {#each formData.rotations as rotation}
                                            <option value={rotation}
                                                >{rotation.description}</option
                                            >
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        {/if}
                        {#if formData}
                            <button
                                class="button"
                                on:click={() => {
                                    updatePlayer();
                                    navigate(-2);
                                }}
                            >
                                Konfiguration speichern
                            </button>
                        {/if}
                        <Button
                            type="submit"
                            on:click={() => {
                                fetch(
                                    "https://keycloak-dev.whizad.io/provision/confirm/" +
                                        $player.uuid +
                                        "/" +
                                        $player.token,
                                    {
                                        method: "PUT",
                                        headers: {
                                            Authorization:
                                                "Bearer " + $user.token,
                                        },
                                    }
                                ).then((res) => statusHandler(res.status));
                            }}>Register Player</Button
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<style>
    main {
        text-align: center;
        padding: 1em;
        max-width: 1024px;
        margin: 0 auto;
    }
    .status {
        margin-bottom: 1rem;
    }

    .select {
        max-width: 15rem;
    }
</style>
